import Api from './Api'

class Lead extends Api {

  constructor(version = 'v1') {
    super(version)
    this.path = 'leads'
  }

  async upload_business_card(data) {
    let bk_data = data.business_card_data
    let dataLength = parseInt((bk_data).replace(/=/g,"").length * 0.75)
    let formData = new FormData()

    bk_data = await this.rightSize(bk_data)

    formData.append('project_id', data.project_id)
    formData.append('origin', "web_app")

    return new Promise((resolve, reject) => {
      this.base64toFile(bk_data, 'a.jpg').then(file=>{
        formData.append('business_card_data', file)

        this.http.post('/leads/create_from_businesscard', formData).then(response => {
          resolve(response.data.resource)
        }).catch(e => {
          this.handleError(e)
          reject(e)
        })
      })
    })
  }

  async rightSize(dataURI){
    let maxLength = 2000000
    let maxSize = 1200
    let sizes = await this.base64sizes(dataURI)
    let ratio = 0

    if(sizes.width > sizes.height){
      ratio = maxSize / sizes.width
    }else{
      ratio = maxSize / sizes.height
    }

    let newDataURI = await this.resizedataURL(dataURI, sizes.width * ratio, sizes.height * ratio)
    return newDataURI
  }

  async resizedataURL(datas, wantedWidth, wantedHeight){
    return new Promise((resolve,reject)=>{

      // We create an image to receive the Data URI
      var img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function(){
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        var dataURI = canvas.toDataURL('image/jpeg', 0.65);
        resolve(dataURI)
      }
      img.src = datas;
    })
  }

  async resizedataURL(datas, wantedWidth, wantedHeight){
    return new Promise((resolve,reject)=>{

      // We create an image to receive the Data URI
      var img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function(){
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        var dataURI = canvas.toDataURL('image/jpeg', 0.65);

        resolve(dataURI)
      }
      img.src = datas;
    })
  }

  async base64sizes(data){
    return new Promise((resolve,reject)=>{
      var i = new Image()
      i.onload = function(){
        resolve({width: i.width, height: i.height})
      }
      i.src = data;
    })
  }

  base64toFile(url, filename, mimeType){
    mimeType = mimeType || (url.match(/^data:([^;]+);/)||'')[1];
    return (fetch(url)
        .then(function(res){return res.arrayBuffer();})
        .then(function(buf){return new File([buf], filename, {type:mimeType});})
    );
  }

  // download_xls(project_id) {
  //   return new Promise((resolve, reject) => {
  //     this.http.get('/leads/download_xls', { params: { project_id: project_id } }).then(response => {
  //       resolve(response.data)
  //     }).catch(e => {
  //       this.handleError(e)
  //       reject(e)
  //     })
  //   });
  // }

  download_pdf(lead_id) {
    return new Promise((resolve, reject) => {
      this.http.get(`/leads/${lead_id}/download_pdf`).then(response => {
        resolve(response.data)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    });
  }

}

export default Lead



// WEBPACK FOOTER //
// ./src/api/Lead.js